import { Currency, GetPricesData, GetPricesResult } from 'hydra-data-types';
import { couponCodeFromQueryParam } from '../../config/AssessmentUtils';
import { LoadingAndErrorState } from '../LoadingAndErrorState';

/** Coupons and pricing for all items (trials and subscriptions) offered.
 * Relevant functions include: `getPrices`.
 * Relevant query params include `plan` */
export type PricingState = Pick<GetPricesResult, 'currency' | 'coupon' | 'itemPrices'> &
  Pick<GetPricesData, 'couponCode'> &
  LoadingAndErrorState;

const initialCurrency = Currency.USD;

export const INITIAL_PRICING_STATE: PricingState = {
  currency: initialCurrency,
  couponCode: couponCodeFromQueryParam(),
  coupon: undefined,
  itemPrices: [],
  loading: false,
  error: undefined,
};
